import React from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderTextField, renderselect } from "../../../../Components/Forms/renders";
import SwitcButton from "../../../../Components/Forms/switch";
import TimeSelect from "../../../../Components/Forms/time";
import MultiSelectDagen from "../../../../Components/Forms/multiselect";

const InsertForm = ({ handleSubmit }) => {
  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            {/* LINKERKOLOM */}
            <div className="col-md-6">
              {/* ALGEMENE INFO */}
              <h5 className="mb-0 mt-3">Algemene informatie</h5>
              <Field name="naam" type="input" validate={[required()]} component={renderField} label="Naam Gasten profiel" />
              <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving standplaats categorie (optioneel)" />

              {/* STROOMINSTELLINGEN */}
              <h5 className="mb-0 mt-4">Stroominstellingen</h5>
              <Field name="betalen" type="input" component={SwitcButton} label="Gasten moeten betalen voor stroom" />
              <Field name="schakelen.in" type="input" component={SwitcButton} label="Gasten mogen stroom inschakelen" />
              <Field name="schakelen.uit" type="input" component={SwitcButton} label="Gasten mogen stroom uitschakelen" />
              <Field name="instellenkwh" type="input" component={SwitcButton} label="Moet er een kWh worden ingesteld" />
              <Field name="instellenamp" type="input" component={SwitcButton} label="Er kunnen ampères worden ingesteld per boeking" />
              <Field name="afwijkingAmpere" type="number" component={renderField} label="Wat is de toegestane afwijking tussen het werkelijke en het ingestelde ampèrage?" />
            </div>

            {/* RECHTERKOLOM */}
            <div className="col-md-6">
              {/* TARIEVEN EN VERBRUIK */}
              <h5 className="mb-0 mt-3">Tarieven & Verbruik</h5>
              <Field name="prijs" type="number" component={renderField} label="Prijs per kWh" />
              <Field name="minimaalkwh" type="number" component={renderField} label="Mimimaal aantal kWh per boeking" />
              <Field name="kwkinclusief" type="number" component={renderField} label="Hoeveel kWh krijgen de gasten inclusief per dag" />

              {/* GEDRAG EN AFHANDELING */}
              <h5 className="mb-0 mt-4">Gedrag & Afhandeling</h5>
              <Field name="oprekening" type="input" component={SwitcButton} label="Gasten betalen op rekening (jaarplaatsen)" />
              <Field name="autouitcheck" type="input" component={SwitcButton} label="Gasten worden automatisch uitgechecked" />

              {/* ALERTS & UITCHECK */}
              <h5 className="mb-0 mt-4">Meldingen & Uitchecktijd</h5>
              <Field name="minaantaldagen" type="input" component={renderField} label="Minimaal aantal dagen" />
              <Field name="uitchecktijd" type="number" component={TimeSelect} label="Tijd van uitchecken" />
              <Field name="sendalert" type="input" options={[50, 60, 70, 80, 90]} component={MultiSelectDagen} label="Kies het aantal procent dat de gast een melding krijgt" />
            </div>
          </div>

          {/* SUBMIT KNOP */}
          <div className="pull-left submit mt-4">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Update" />
          </div>
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(
  reduxForm({
    form: "kampeerplaatscategorieinsert",
  })(InsertForm)
);
